// Shared colour treatment for N/A Day UI (calendar blocks + sidebar chip).
// Derives a legible event-style palette from the admin's configured hex: a light
// tint background, a darkened same-hue text colour, and a mid-shade border — so
// the label stays readable whatever colour is picked, matching how other
// calendar events render. Falls back to a plain background fill on a bad hex.

// Parse a #rgb / #rrggbb string to {r,g,b}, or null if it isn't a valid hex.
function hexToRgb(hex) {
  if (typeof hex !== 'string') return null;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) h = h.split('').map(c => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  const n = parseInt(h, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

// Blend rgb toward a target ({r,g,b}) by `amt` (0..1 = weight of target).
function mix({ r, g, b }, target, amt) {
  const c = (a, t) => Math.round(a * (1 - amt) + t * amt);
  return `rgb(${c(r, target.r)}, ${c(g, target.g)}, ${c(b, target.b)})`;
}

const WHITE = { r: 255, g: 255, b: 255 };
const BLACK = { r: 0, g: 0, b: 0 };

export default function naStyle(colour) {
  const rgb = hexToRgb(colour);
  if (!rgb) return { backgroundColor: colour };
  return {
    backgroundColor: mix(rgb, WHITE, 0.80), // light tint
    borderColor: mix(rgb, BLACK, 0.30), // mid shade
    color: mix(rgb, BLACK, 0.55), // dark same-hue text
  };
}
